// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-form-component.register-dropdown {
  width: 33.8rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderRegistrationLayout/index.scss"],"names":[],"mappings":"AACE;EACE,cAAA;AAAJ","sourcesContent":[".dropdown-form-component {\n  &.register-dropdown {\n    width: 33.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
